//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IGetLike2BuyAccountDataResponse,
  ILike2BuyCustomizationsResponse,
} from '@apis/like2buy/like2buyLegacyApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedSessionFetch } from '@utils/sessionFetch';

const like2buyFetch = (
  endpoint: string,
  init?: RequestInit,
  useFetchHeader?: boolean,
) => {
  return serializedSessionFetch(
    `/api/v2/like2buy${endpoint}`,
    init,
    useFetchHeader,
  );
};

/**
 * TODO: Remove this once new endpoint is added (DEV-59019)
 *
 * Gets Like2Buy store data
 *
 * /api/v2/like2buy/account
 *
 */
export const getLike2BuyAccountData =
  async (): Promise<IGetLike2BuyAccountDataResponse> => {
    const res = await like2buyFetch('/account');
    return await res.json();
  };

/**
 * Gets Like2Buy store customization settings
 *
 * /api/v2/like2buy/customize
 *
 */
export const getLike2BuyCustomizationSettings =
  async (): Promise<ILike2BuyCustomizationsResponse> => {
    const res = await like2buyFetch('/customize');
    return res.json();
  };

// TODO PD-245819: Clean up dual write
export const uploadCustomBanner = async (
  file: File,
  tributaryName: string,
  currentVersion: number,
  forMobile: boolean,
) => {
  const params = makeParams({
    tributaryName,
    version: currentVersion + 1,
    forMobile,
  });

  const formData = new FormData();

  formData.append('file', file);

  const res = await like2buyFetch(
    `/customize/upload-poster?${params}`,
    {
      method: 'POST',
      body: formData,
    },
    true, // Browser will set the content type, required for form data
  );

  if (res.ok) {
    const url = await res.text();
    return url;
  }
};

export const updateCustomizations = async (body: {
  implId: string;
  tributaryName: string;
  squareCropConfig: {
    isEnabled: boolean;
  };
  emailCaptureConfig: {
    isEnabled: boolean;
    callToAction?: string;
  };
  posterImageConfig: {
    isEnabled: boolean;
    posterPassthroughUrl?: string;
    mobilePosterImg?: string;
    mobileVersion?: number;
    desktopPosterImg?: string;
    desktopVersion?: number;
  };
  customStringsConfig: {
    desktopGalleryHeader?: string;
    mobileGalleryHeader?: string;
    multiproductHeader?: string;
  };
  isPreview: boolean;
  previewUrl: string;
  previewImplId: string;
}) => {
  const res = await like2buyFetch('/customize', {
    method: 'PUT',
    body: JSON.stringify(body),
  });

  return res;
};
